import reducer from "./reducer";
import * as actions from "./actions";
import * as constants from "./constants";
import * as selectors from "./selectors";

export default {
  actions,
  constants,
  reducer,
  selectors,
};
